import theme from '@/theme'
import { makeStyles } from '@mui/styles'
import React from 'react'

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  statusCircle: {
    display: 'flex',
    minWidth: 10,
    maxWidth: 10,
    minHeight: 10,
    maxHeight: 10,
    borderRadius: '50%',
    marginRight: 20,
  },
}))

const StateCellRenderer = (props) => {
  const classes = useStyles()
  const statusColor = props.colDef.getStatusColor?.(props.value) || theme.greyStateColor
  const label = props.valueFormatted || props.getValue()

  return (
    <div className={classes.container}>
      <div className={classes.statusCircle} style={{ background: statusColor }} />
      <div>{label}</div>
    </div>
  )
}

export default StateCellRenderer
